/* ============================================================================
   mm-main-product-helper.js — logique JS de la fiche produit
   ----------------------------------------------------------------------------
   Chargé uniquement par sections/main-product.liquid (balise <script> en fin
   de section). Regroupe :
   - accordéons descriptifs (mmShowAccordeonContent) ;
   - sélecteur de quantité + prix du CTA (mmQtty / mmUpdatePrice) ;
   - popup vidéo (displayForVideo) et chat Tidio mobile ;
   - le custom element <variant-selector> : changement de variante avec
     re-fetch de la section via ?variant=X&section_id=Y (Section Rendering) ;
   - les accessoires cochables (.mm-accessory-card) : prix du bouton
     (updateCTAButtonPrice), prix réduits conditionnels (updateCardPrices).
   Travaille main dans la main avec assets/mm_cart.js qui fournit
   mmAddProductToCart() et updateProgressBarPreview()/updateProgressBarFull()
   (appelées ici : ce fichier suppose mm_cart.js déjà chargé).
   ========================================================================== */

// Ouvre/ferme un accordéon de la fiche produit (animation height 0 → scrollHeight).
// Appelée en onclick sur les titres d'accordéon dans sections/main-product.liquid.
function mmShowAccordeonContent(elemToShowClass, titleClass) {
    var accordeonToShow = document.querySelector(elemToShowClass);
    var title = document.querySelector(titleClass);

    var accordeonHeight = accordeonToShow.scrollHeight;
    if (accordeonToShow.style.height == "0px" || accordeonToShow.style.height == "") {
        accordeonToShow.style.height = accordeonHeight + "px";
    } else {
        accordeonToShow.style.height = "0px";
    }

    title.classList.toggle("mm-active");
}

// Incrémente/décrémente le champ quantité (.mm-product-qtty-number), plancher
// à 1, puis recalcule les prix affichés. Appelée en onclick sur les boutons
// +/− de sections/main-product.liquid (mmQtty(1) / mmQtty(-1)).
function mmQtty(delta) {
    var number = document.querySelector(".mm-product-qtty-number");
    var oldValue = number.value;
    if (oldValue == 1 && delta == -1) {
    } else {
        let newValue = parseInt(oldValue, 10) + parseInt(delta, 10);
        number.value = newValue;
	      mmUpdatePrice(newValue);

    }
}

// Réaffiche tous les prix (.mm-product-price-update) = prix unitaire
// (data-value, en centimes) × quantité. Appelée uniquement par mmQtty.
// NB : symbole € en dur et point décimal (pas de virgule ici, contrairement
// aux autres formatages du thème).
function mmUpdatePrice(qtty) {
  let priceAll = document.querySelectorAll(".mm-product-price-update");
  priceAll.forEach(function (price) {
    price.innerHTML = `${((price.dataset.value * qtty) / 100).toFixed(2)}€`;
  });
}


// Ouvre/ferme la popup vidéo produit : fige le scroll et fixe le header en
// "open" ; en "close", remet le scroll et stoppe + rembobine la vidéo.
// Appelée en onclick depuis sections/main-product.liquid (croix des popups
// .mm-product-popup-video / -proof).
// NB : `new Vimeo.Player()` est tenté systématiquement — le constructeur
// renvoie toujours un objet, donc la branche else (vidéo HTML5 native,
// mmVideo.pause()) est inatteignable ; et si la lib Vimeo n'est pas chargée,
// l'appel lève une ReferenceError.
function displayForVideo(statut) {
    var header = document.querySelector(".header-wrapper");
    if (statut == "open") {
        document.querySelector("html").classList.add("stop-scrolling");
        header.classList.add("mm-header-fixed-video");
    } else if (statut == "close") {
        document.querySelector("html").classList.remove("stop-scrolling");
        header.classList.remove("mm-header-fixed-video");
        var mmVideo = document.querySelector(".mm-video-popup_video-content");
        var playerVimeo = new Vimeo.Player(mmVideo);
        if (playerVimeo != null) {
          playerVimeo.pause().then(function () {
            return playerVimeo.setCurrentTime(0);
          });
        } else {
          mmVideo.pause();
          mmVideo.currentTime = 0;
        }
    }
}

// ===== Chat Tidio (mobile uniquement) =====
// Sur mobile, le widget Tidio est caché par défaut et n'apparaît qu'au clic
// sur le bouton custom .chat-button (rendu par sections/main-product.liquid).
// À la fermeture du chat, on re-cache la bulle et on nettoie tous les styles
// inline que Tidio laisse sur <html>/<body> (sinon la page reste figée).
// ⚠️ 09.07.2026 — POST-MORTEM : depuis le relift (17/06), le chat IA a remplacé
// Tidio et .chat-button n'existe PLUS sur la PDP. L'addEventListener non
// protégé jetait un TypeError qui TUAIT TOUT CE FICHIER sur mobile
// (innerWidth<768) : VariantSelector jamais défini → sélection de variante
// morte (bug « 2XL ajoute XL au panier ») + barre d'info figée + prix
// accessoires morts. Invisible sur desktop (bloc entier sauté). D'où la garde
// ci-dessous : ce bloc ne doit JAMAIS pouvoir tuer le reste du fichier.
if (window.innerWidth < 768) {
    (function () {
        function onTidioChatApiReady() {
            window.tidioChatApi.hide();
            window.tidioChatApi.on("close", function () {
                window.tidioChatApi.hide();
                var html = document.querySelector("html");
                var body = document.querySelector("body");
                html.style.overflow = "";
                html.style.margin = "";
                body.style.overflow = "";
                body.style.height = "";
                body.style.width = "";
                body.style.visibility = "";
                body.style.display = "";
                body.style.inset = "";
                body.style.margin = "";
                body.style.opacity = "";
            });
        }

        if (window.tidioChatApi) {
            window.tidioChatApi.on("ready", onTidioChatApiReady);
        } else {
            document.addEventListener("tidioChat-ready", onTidioChatApiReady);
        }

        var mmChatBtn = document.querySelector(".chat-button");
        if (mmChatBtn) {
            mmChatBtn.addEventListener("click", function () {
                window.tidioChatApi.show();
                window.tidioChatApi.open();
            });
        }
    })();
}

// FORM
// Custom element <variant-selector> (markup dans sections/main-product.liquid,
// événements "change" aussi dispatchés programmatiquement par
// sections/MM-Modal-Tailles.liquid quand on choisit un téléphone).
// À chaque changement d'option : retrouve la variante dans le JSON inline
// (.mm-main-product-json), met à jour l'URL (?variant=), les prix des cards
// (côté client, sans flash), re-fetch la section rendue serveur
// (?variant=X&section_id=Y, avec cache mémoire) pour swapper prix/CTA/infos,
// et bascule la galerie sur l'image de la variante.
class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.cached = {};
    this.container = this.closest("#product-form");
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    if (this.currentVariant) {
      // 09.07.2026 (bug mobile "2XL ajoute XL au panier") : écrit l'ID de la
      // variante choisie TOUT DE SUITE dans le champ caché lu par l'ajout au
      // panier (#mmSelectedProductId, lu par mmValidationButton). Avant, ce
      // champ n'était réécrit qu'à la FIN du fetch de section
      // (variantFetch -> renderVariantInfo) : sur mobile (réseau plus lent +
      // CTA sticky sous le pouce), taper "Ajouter" avant la réponse envoyait
      // l'ancienne variante (la 1re / défaut) au panier. Le fetch repasse
      // ensuite avec la même valeur -> aucun changement pour le reste.
      const idInput = (this.container || document).querySelector("#mmSelectedProductId");
      if (idInput) idInput.value = this.currentVariant.id;
      // Même course pour la barre d'info sous les cartes : son texte
      // n'arrivait qu'avec le fetch -> perçue comme figée sur mobile (sur
      // desktop, le JS de survol data-helpbar masquait le retard). On copie
      // en synchrone le data-helpbar de la carte sélectionnée quand il existe
      // (le fetch resynchronisera avec le rendu serveur, valeur identique).
      const mmCheckedInput = this.querySelector(".mm-product-variant-input:checked");
      const mmSelectedCard = mmCheckedInput && mmCheckedInput.parentElement
        ? mmCheckedInput.parentElement.querySelector(".mm-selector-card[data-helpbar]")
        : null;
      const mmHelpbarText = (this.container || document).querySelector(".mm-selector-variants-container-info-tels [data-helpbar-text]");
      if (mmSelectedCard && mmHelpbarText && mmSelectedCard.dataset.helpbar) {
        mmHelpbarText.textContent = mmSelectedCard.dataset.helpbar;
      }

      this.updateURL();
      // Met à jour immédiatement les prix des cards variants (mm-vs2-label-db-price)
      this.updateVariantCardsPrices();
      this.variantFetch();
      this.updateMedia();
    }
  }

  getSelectedOptions() {
    // Cas 1 : sélecteurs classiques (select)
    if (this.querySelector("select.mm-product-form-variant-values")) {
      this.options = Array.from(
        this.querySelectorAll("select.mm-product-form-variant-values"),
        (select) => select.value
      );
    } 
    // Cas 2 : sélecteurs avec radios (nouvelle version)
    else {
      this.options = Array.from(
        this.querySelectorAll(".mm-product-variant-input:checked, input[type='radio'][name^='mm_options_']:checked"),
        (input) => input.value
      );
    }
  }

  getVariantJSON() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('.mm-main-product-json[type="application/json"]').textContent);
    return this.variantData;
  }

  // Résolution de la variante : d'abord par public_title "Opt1 / Opt2"
  // (fragile : dépend du séparateur exact de Shopify), sinon fallback par
  // comparaison position à position du tableau options.
  getSelectedVariant() {
    const variants = this.getVariantJSON();

    // Si on a 2 options sélectionnées (ex: Catégorie + Adaptateur)
    if (this.options.length >= 2) {
      const joined = `${this.options[0]} / ${this.options[1]}`;
      this.currentVariant = variants.find(v => v.public_title === joined);
      if (this.currentVariant) return;
    }

    // Sinon on essaie de matcher par tableau d’options (fallback)
    this.currentVariant = variants.find(variant => {
      if (!variant.options) return false;
      return !variant.options
        .map((opt, i) => this.options[i] === opt)
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}#mm-selector`
    );
  }

  // Re-fetch de la section produit rendue serveur pour la variante choisie
  // (Section Rendering API). Le HTML parsé est mis en cache par URL pour
  // rendre instantanés les allers-retours entre variantes.
  variantFetch() {
    const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

    if (this.cached[variantUrl]) {
      this.renderVariantInfo(this.cached[variantUrl]);
      return;
    }

    fetch(variantUrl)
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, "text/html");
        this.cached[variantUrl] = html;
        this.renderVariantInfo(html);
      })
      .catch((e) => console.error(e));
  }

  renderVariantInfo(html) {
    this.updateElementOuter("#mmSelectedProductId", html);
    this.updateElementOuter(`#price-${this.dataset.section}`, html);
    this.updateElementOuter(".mm-product-form-submit-button", html);
    // Info tels (metafield custom.info_tels) — swap depuis le HTML serveur.
    // La div est toujours rendue côté Liquid (même vide) pour que ce swap
    // marche aussi en passant d'une variante avec info_tels à une sans.
    this.updateElement(".mm-selector-variants-container-info-tels", html);
    // On ne touche plus aux éléments .mm-reload (prix dans les cards variants)
    // pour éviter tout "flash" : les prix sont mis à jour côté client dans updateVariantCardsPrices().
  }

  /**
   * Met à jour les prix affichés dans les cards variants (design B)
   * en fonction de la catégorie sélectionnée, sans attendre le fetch serveur.
   */
  updateVariantCardsPrices() {
    const variants = this.getVariantJSON();
    if (!this.options || this.options.length === 0) return;
    const selectedOption1 = this.options[0]; // Catégorie sélectionnée

    // Chaque card design B possède un input radio juste avant le label .mm-vs2-label-db
    const cards = this.container
      ? this.container.querySelectorAll('.mm-vs2-label-db')
      : [];

    cards.forEach(card => {
      const input = card.previousElementSibling;
      if (!input || !input.value) return;

      const option2Value = input.value;

      const matchingVariant = variants.find(v =>
        v.option1 === selectedOption1 && v.option2 === option2Value
      );

      if (!matchingVariant) return;

      const priceEl = card.querySelector('.mm-vs2-label-db-price');
      if (!priceEl) return;

      const priceCents = parseInt(matchingVariant.price, 10);
      if (!priceCents) return;

      const priceFormatted = (priceCents / 100).toFixed(2).replace('.', ',') + '€';
      priceEl.textContent = priceFormatted;
    });
  }

  // Helpers de swap DOM depuis le HTML re-fetché : innerHTML (updateElement),
  // outerHTML (updateElementOuter), ou liste appariée par index
  // (updateMultipleElement — plus utilisé par renderVariantInfo actuellement).
  updateElement(selector, html) {
    const dest = this.container.querySelector(selector);
    const src = html.querySelector(selector);
    if (src && dest) dest.innerHTML = src.innerHTML;
  }

  updateElementOuter(selector, html) {
    const dest = this.container.querySelector(selector);
    const src = html.querySelector(selector);
    if (src && dest) dest.outerHTML = src.outerHTML;
  }

  updateMultipleElement(selector, html) {
    const dests = this.container.querySelectorAll(selector);
    const srcs = html.querySelectorAll(selector);
    if (srcs.length && dests.length) {
      for (let i = 0; i < srcs.length; i++) {
        if (dests[i] && srcs[i]) dests[i].outerHTML = srcs[i].outerHTML;
      }
    }
  }

  // Bascule la galerie sur l'image associée à la variante : simule un clic
  // sur la miniature Splide correspondante (#thumbnail-carousel).
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const mediaId = this.currentVariant.featured_media.id;
    document.querySelectorAll("#thumbnail-carousel .splide__slide").forEach((media) => {
      if (media.dataset.id && media.dataset.id == mediaId) {
        media.click();
      }
    });
  }
}

customElements.define("variant-selector", VariantSelector);


// Bloc mort (Bold Bundles) : déjà commenté, et contiendrait du Liquid
// ({{ section.id }}) qui n'est jamais interprété dans un asset .js.
// window.addEventListener("load", function () {
//     setTimeout(function () {
//         const comboInclude = document.querySelector(".bold-bundles-product");
//         if (comboInclude != undefined) {
//             const parentDiv = document.getElementById("mm-bundle-product-{{ section.id }}");
//             if (parentDiv != undefined) {
//                 parentDiv.appendChild(comboInclude);
//             }
//         }
//     }, 50);
// });


/* Toggle Quick Upsell (plaque métal) */
// Au clic sur la carte upsell, toggle la classe mm-upsell-add-to-card (lue
// par mmAddProductToCart dans mm_cart.js via .mm-clickable / état de la carte)
// et permute l'affichage des deux prix du CTA.
// NB : getElementById("product-form") sans garde — le script planterait sur
// une page sans #product-form (OK tant qu'il n'est chargé que par
// sections/main-product.liquid).
const productForm = document.getElementById("product-form");
const quickUpsell = productForm.querySelector('.mm-upsell-product-container');

if (quickUpsell) {
  const priceContainerAll = productForm.querySelectorAll(".mm-quick-upsell-price");
  quickUpsell.addEventListener("click", () => {
    quickUpsell.classList.toggle("mm-upsell-add-to-card");
    priceContainerAll.forEach((priceContainer) => {
      priceContainer.classList.toggle("hidden");
    })
  })
}

// ACCESSORIES
document.addEventListener("DOMContentLoaded", function () {
  mmSetupProductAccessorties();
});
// Fonction quasi NO-OP (et typo dans le nom : "Accessorties").
// Elle lit basePrice et définit formatPrice mais n'en fait RIEN : reliquat
// d'une ancienne implémentation. Effet de bord réel possible : TypeError au
// DOMContentLoaded si .mm-quick-upsell-price .mm-product-price-update est
// absent (priceDisplayElements[0] undefined).
function mmSetupProductAccessorties() {
  const accessoryCheckboxes = document.querySelectorAll(".mm-product-accessories-container input[type='checkbox']");
  const priceDisplayElements = document.querySelectorAll(".mm-cta-price.mm-quick-upsell-price .mm-product-price-update");

  // Prix du produit principal
    //console.log('priceDisplayElements[0]', priceDisplayElements[0])
    const basePrice = parseInt(priceDisplayElements[0].dataset.price); // Exemple: 4995 = 49,95€
    //console.log('priceDisplayElements[0].dataset.price', priceDisplayElements[0].dataset.price)

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }
};


// Recalcule le prix affiché sur le bouton d'achat : prix de la variante
// + accessoires cochés (au prix réduit si la remise est visible sur la card),
// avec gestion du prix barré (compare_at) masqué quand il n'apporte rien.
// Appelée par checkThisCard à chaque (dé)coche d'accessoire.
function updateCTAButtonPrice() {
  const visiblePriceElem = document.querySelector('#product-form .mm-product-price-update');
  if (!visiblePriceElem) return;

  // Base : prix variant (réel) et prix de référence (compare_at, fallback price)
  const basePrice = parseInt(visiblePriceElem.getAttribute('data-price')) || 0;
  const baseComparePrice =
    parseInt(visiblePriceElem.getAttribute('data-compare-price')) || basePrice;

  // Somme des accessoires cochés : prix payé (réduit si applicable) vs prix de référence (data-price)
  const checkedAccessories = document.querySelectorAll('.mm-accessory-card input[type="checkbox"]:checked');
  let accessoriesTotal = 0;
  let accessoriesTotalCompare = 0;

  checkedAccessories.forEach(input => {
    const card = input.closest('.mm-accessory-card');
    const unchangedPrice = !!card.querySelector('[data-unchanged]');
    const reducedVisible =
      !unchangedPrice && card.querySelector('[data-reduced]')?.style.display !== 'none';

    const fullPrice = parseInt(input.getAttribute('data-price')) || 0;
    const paidPrice = reducedVisible
      ? parseInt(input.getAttribute('data-price-reduced')) || fullPrice
      : fullPrice;

    accessoriesTotal += paidPrice;       // ce qu'on paie
    accessoriesTotalCompare += fullPrice; // référence (data-price, conformément à la convention)
  });

  const total = basePrice + accessoriesTotal;
  const totalCompare = baseComparePrice + accessoriesTotalCompare;

  // Maj du prix payé
  const priceUpdateElems = document.querySelectorAll('#product-form .mm-cta-price .mm-product-price-update');
  priceUpdateElems.forEach(el => {
    el.setAttribute('data-value', total);
    el.innerHTML = `${(total / 100).toFixed(2).replace('.', ',')}€`;
  });

  // Maj du prix barré : afficher uniquement si totalCompare > total
  const comparePriceUpdateElems = document.querySelectorAll('#product-form .mm-cta-price .mm-product-compare-price-update');
  const showCompare = totalCompare > total;
  comparePriceUpdateElems.forEach(el => {
    if (showCompare) {
      el.style.display = '';
      el.setAttribute('data-value', totalCompare);
      el.innerHTML = `${(totalCompare / 100).toFixed(2).replace('.', ',')}€`;
    } else {
      el.style.display = 'none';
    }
  });
}

// Handler onchange des checkboxes accessoires (snippets/mm-accessory-card.liquid).
// Toggle le style de la card puis resynchronise prix CTA, barre de paliers
// (updateProgressBarPreview — définie dans mm_cart.js) et prix des cards.
function checkThisCard(checkbox) {
  const card = checkbox.closest('.mm-accessory-card');
  card.classList.toggle('mm-active', checkbox.checked);

  updateCTAButtonPrice();
  updateProgressBarPreview(); 
  updateCardPrices();
}

// Affiche/masque les prix réduits ([data-reduced] vs [data-original]) sur les
// cards accessoires. Règle métier : la remise ne s'applique qu'aux cards de
// type "Accessoires", qu'à la PREMIÈRE card cochée, et seulement si le total
// prédictif (produit + panier) atteint le seuil. Met aussi à jour
// checkbox.dataset.displayedPrice, lu par updateProgressBarFull (mm_cart.js).
// ATTENTION : seuil 2900 en dur ici, alors que updatePricesBasedOnCart
// (mm_cart.js) utilise 3000 pour la même logique — incohérence probable.
// Même piège que dans mm_cart.js : querySelector('data-accessory-in-cart')
// teste l'existence de la balise sans vérifier value="true".
function updateCardPrices() {
  const cards = document.querySelectorAll('.mm-accessory-card-wrapper');

  // Un accessoire remisé est DÉJÀ au panier → le créneau "1 accessoire à -50%"
  // est CONSOMMÉ → on force TOUTES les cartes au plein tarif (plus aucun prix
  // barré). (Bug 19/06 : avant on faisait juste `return`, ce qui laissait les
  // cartes à leur état -50% précédent — d'où les lumières/accessoires encore
  // barrés alors que la remise était déjà utilisée.)
  if (document.querySelector('data-accessory-in-cart')) {
    cards.forEach(card => {
      card.querySelectorAll('[data-reduced]').forEach(el => el.style.display = 'none');
      card.querySelectorAll('[data-original]').forEach(el => el.style.display = 'block');
      const cb = card.querySelector('input[type="checkbox"]');
      if (cb) cb.dataset.displayedPrice = cb.dataset.price;
    });
    return;
  }

  const checkedCards = Array.from(cards).filter(card => card.querySelector('input[type="checkbox"]').checked);
  // Bug lumières (19/06) : seuls les accessoires ÉLIGIBLES (type "Accessoires")
  // "consomment" le créneau -50%. Un non-accessoire coché (ex. lumières) ne doit
  // PAS retirer le -50% des vrais accessoires (plaque/cordon).
  const checkedAccessoryCards = checkedCards.filter(card => card.dataset.type === 'Accessoires');

  // dataset.PRICE (variante seule, rendu serveur) et pas dataset.value :
  // value est réécrit par updateCTAButtonPrice() en « variante + accessoires
  // cochés » → un accessoire coché gonflerait le prédictif qui pilote le
  // seuil d'affichage du -50% (même bug que la frise, corrigé 29/07/2026).
  const product_value = parseInt(document.querySelector('#mmDataPriceElem')?.dataset.price || 0);
  const cart_value = parseInt(document.querySelector('.mm-dc-cta')?.dataset.totalPrice || 0);
  const total_predictive_value = product_value + cart_value;

  //console.log('total_predictive_value ::', total_predictive_value)

  if (total_predictive_value >= 2900) {
    //console.log('on affiche les prix réduits');
    if (checkedAccessoryCards.length === 0) {
      // Aucun accessoire ÉLIGIBLE coché (panier vide OU seulement des non-accessoires
      // type lumières) : on (ré)affiche le -50% sur TOUS les accessoires éligibles
      cards.forEach(card => {
        const reducedAll = card.querySelectorAll('[data-reduced]');
        const originalAll = card.querySelectorAll('[data-original]');
        const isAccessory = card.dataset.type === 'Accessoires';
        //console.log('isAccessory', isAccessory)

        if (isAccessory) {
          if (reducedAll) {
            reducedAll.forEach(function(reduced) {
              reduced.style.display = 'block';
            })
          }
          if (originalAll) {
            originalAll.forEach(function(original) {
              original.style.display = 'none';
            })
          }
        } else {
          // Pas un accessoire → on garde le prix normal
          if (reducedAll) {
            reducedAll.forEach(function(reduced) {
              reduced.style.display = 'none';
            })
          }
          if (originalAll) {
            originalAll.forEach(function(original) {
              original.style.display = 'block';
            })
          }
        }
      });
    } else {
      // Une ou plusieurs cartes cochées
      cards.forEach(card => {
        const checkbox = card.querySelector('input[type="checkbox"]');
        const reducedAll = card.querySelectorAll('[data-reduced]');
        const originalAll = card.querySelectorAll('[data-original]');
        const isAccessory = card.dataset.type === 'Accessoires';

        if (!checkbox.checked) {
          // Non cochée → prix normal
          if (reducedAll) {
            reducedAll.forEach(function(reduced) {
              reduced.style.display = 'none';
            })
          }
          if (originalAll) {
            originalAll.forEach(function(original) {
              original.style.display = 'block';
            })
          }
          checkbox.dataset.displayedPrice = checkbox.dataset.price;
        } else {
          if (card === checkedAccessoryCards[0]) {
            // Premier accessoire ÉLIGIBLE coché → prix réduit (le créneau -50%)
            if (reducedAll) {
              reducedAll.forEach(function(reduced) {
                reduced.style.display = 'block';
              })
            }
            if (originalAll) {
              originalAll.forEach(function(original) {
                original.style.display = 'none';
              })
            }
            checkbox.dataset.displayedPrice = checkbox.dataset.priceReduced;
          } else {
            // Sinon prix normal (ou si ce n’est pas un accessoire)
            if (reducedAll) {
              reducedAll.forEach(function(reduced) {
                reduced.style.display = 'none';
              })
            }
            if (originalAll) {
              originalAll.forEach(function(original) {
                original.style.display = 'block';
              })
            }
            checkbox.dataset.displayedPrice = checkbox.dataset.price;
          }
        }
      });
    }
  } else {
    //console.log('on n\'affiche pas les prix réduits');
    // on n'affiche pas les prix réduits
    cards.forEach(card => {
      const reducedAll = card.querySelectorAll('[data-reduced]');
      const originalAll = card.querySelectorAll('[data-original]');
      if (reducedAll) {
        reducedAll.forEach(function(reduced) {
          reduced.style.display = 'none';
        })
      }
      if (originalAll) {
        originalAll.forEach(function(original) {
          original.style.display = 'block';
        })
      }
    });
  }
}


// Appeler au load de la page
// Premier rendu de la barre de paliers (fonction définie dans mm_cart.js,
// qui doit donc être chargé avant ce fichier).
window.addEventListener('DOMContentLoaded', updateProgressBarPreview);


// Offset du fil d'Ariane sticky : on pose --mm-header-h = hauteur réelle du
// header sticky (différente mobile/desktop), lue par .mm-breadcrumbs-sticky
// dans main-product.css. Recalculée au load et au resize/rotation.
(function () {
  function setHeaderHeight() {
    var header = document.querySelector('.shopify-section.section-header');
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--mm-header-h', h + 'px');
  }
  setHeaderHeight();
  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('orientationchange', setHeaderHeight);
})();


// ----------------------------------------------------------------------------
// Survol des cartes des sélecteurs (produit / support) — DESKTOP uniquement.
// Au survol d'une carte, la barre d'info affiche le texte de CETTE carte
// (attribut data-helpbar, posé par le snippet mm-selector-card) ; en quittant,
// la barre revient au texte de la carte réellement sélectionnée (variante cochée
// pour le sélecteur produit, produit courant .mm-selector-card-selected pour le
// support), ou au texte initial à défaut. Sur mobile (pas de hover) : aucun effet.
// Cible de la barre = le <p data-helpbar-text> rendu dans main-product.liquid.
// ----------------------------------------------------------------------------
(function () {
  function initSelectorHelpbarHover() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (min-width: 769px)').matches) return;

    document.querySelectorAll('[data-helpbar-text]').forEach(function (bar) {
      var scope = bar.closest('.mm-selector-variants, .mm-selector-support');
      if (!scope) return;
      var cards = scope.querySelectorAll('.mm-selector-card[data-helpbar]');
      if (!cards.length) return;

      var defaultText = bar.textContent;

      // Texte de la carte actuellement sélectionnée (suit la vraie sélection,
      // même après un clic sur une variante), sinon le texte initial.
      function selectedText() {
        var activeCard = null;
        var checked = scope.querySelector('.mm-product-variant-input:checked');
        if (checked) {
          var wrap = checked.closest('.mm-product-variant');
          if (wrap) activeCard = wrap.querySelector('.mm-selector-card[data-helpbar]');
        }
        if (!activeCard) activeCard = scope.querySelector('.mm-selector-card-selected[data-helpbar], .mm-selector-card-page[data-helpbar]');
        var t = activeCard && activeCard.getAttribute('data-helpbar');
        return (t && t.trim()) ? t : defaultText;
      }

      cards.forEach(function (card) {
        card.addEventListener('mouseenter', function () {
          var t = card.getAttribute('data-helpbar');
          if (t && t.trim()) bar.textContent = t;
        });
        card.addEventListener('mouseleave', function () {
          bar.textContent = selectedText();
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectorHelpbarHover);
  } else {
    initSelectorHelpbarHover();
  }
})();





